import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import App from './reducers/app/reducer';
import LanguageSwitcher from './reducers/languageSwitcher/reducer';
import auth from '@stores/reducers/auth.reducer';
import company from '@stores/reducers/company.reducer';
import notification from '@stores/reducers/notification.reducer';
import solicitationCostCenterReducer from './reducers/solicitationCostCenterSlice';
import menu from './reducers/menu.reducer';

const rootReducer = combineReducers({
  App,
  LanguageSwitcher,
  auth,
  company,
  notification,
  solicitationCostCenter: solicitationCostCenterReducer,
  menu,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'company', 'notification', 'solicitationCostCenterReducer'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  })
});

const persistor = persistStore(store);

export { store, persistor };
